import { BaseTokenModule } from './base'
import React from 'react'
import { Button, Spacer } from '@spritz-finance/ui'
import { TokenImage } from '../../TokenListItem'
import { ButtonsWrapper } from '../ButtonsWrapper'
import { TokenBalance } from '../../../../../../graphql/generated/graphql'
import { useWalletAction } from '../useWalletAction'

const NativeTokenPaymentButton: React.VFC<{ submitting: boolean; token: TokenBalance }> = ({
    submitting,
    token,
}) => {
    const action = useWalletAction()

    return (
        <ButtonsWrapper>
            <Button.CTA variant="gradient" type="submit" loading={submitting}>
                {action} <Spacer width={4} />
                <TokenImage src={token.tokenImageUrl} />
            </Button.CTA>
        </ButtonsWrapper>
    )
}

export class EVMNativeTokenModule extends BaseTokenModule {
    paymentRequiresAllowance() {
        return false
    }

    content(args: any): JSX.Element {
        return <NativeTokenPaymentButton token={this.token} submitting={args.submitting} />
    }
}
